interface PaymentScheduleAmountRow {
  percentage?: number | null
  amount?: number | null
}

export function recalcPaymentScheduleAmounts<
  T extends PaymentScheduleAmountRow
>(schedule: T[], total: number): T[] | null {
  // A stale discount can outlive the line items it was entered against, leaving
  // the total negative; NaN gets here the same way. Neither may reach an amount.
  const payableTotal = total > 0 ? total : 0

  let changed = false

  const updated = schedule.map((row) => {
    const percentage = +(row?.percentage || 0)

    // A row with an amount but no percentage has nothing to derive from —
    // rewriting it would zero a figure the user or the API supplied.
    if (!percentage) return row

    const amount = Math.round((percentage / 100) * payableTotal * 100) / 100
    if (amount === row?.amount) return row

    changed = true
    return { ...row, amount }
  })

  return changed ? updated : null
}
